import { sendProductReviewsEvent as send } from 'src/tracking/sendProductReviewsEvent';

export const trackDrawerOpen = () => send('Reviews drawer open', 'not set');

/** `all` when the filter is cleared, so the two directions are distinguishable in GA. */
export const trackRatingFilter = (rating: number | null) =>
  send('Reviews rating filter', rating === null ? 'all' : String(rating));

export const trackPaginationClick = (page: number) => send('Pagination click', String(page));

export const trackNextPageClick = (page: number) => send('Next page click', String(page));

export const trackPreviousPageClick = (page: number) => send('Previous page click', String(page));

export const trackRatingSystemInfoOpen = (productCode: number) =>
  send('Product rating system click', String(productCode));

/**
 * Arrival via a `#reviews-drawer-{id}` link. There is no share control to instrument, so
 * the arrival is the measurable half of "review share".
 */
export const trackSharedReviewOpen = (reviewId: string) => send('Shared review open', reviewId);
